import { Component, Inject, OnInit } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { TypeCesEnum } from 'src/app/domain/registration/enums/type-ces.enum';
import { ToastService } from 'src/app/shared/services/toast/toast.service';

@Component({
  selector: 'app-customer-to-update-plans-reason-dialog',
  templateUrl: './customer-to-update-plans-reason-dialog.component.html',
  styleUrls: ['./customer-to-update-plans-reason-dialog.component.sass']
})
export class CustomerToUpdatePlansReasonDialog implements OnInit {
  element: any = {};
  title = '';

  constructor(
    public toastService: ToastService,
    public dialogRef: MatDialogRef<CustomerToUpdatePlansReasonDialog>,
    @Inject(MAT_DIALOG_DATA)
    data: {
      title: string;
      typeCes: TypeCesEnum;
      element: any;
    }
  ) {
    if (data?.title) this.title = data.title;
  }

  ngOnInit(): void {}

  public clickNo() {
    this.dialogRef.close(false);
  }

  public clickOk() {
    if (this.element?.updateReason)
      this.dialogRef.close({
        result: true,
        updateReason: this.element?.updateReason,
      });
    else this.toastService.showWarn('Informe o motivo da atualização.');
  }
}
